@if (isLoading()) {
  <app-preloader></app-preloader>
}
<app-notifications></app-notifications>

<div class="insurance" *ngIf="showInsurance()" [ngClass]="{ openQuote: quoteType() == 1 }">
  <div class="title">
    <h3>Seguro</h3>
    <div class="actions">
      <a class="delete" tp="Eliminar seguro" (click)="deleteInsurance()" (keydown.enter)="deleteInsurance()"
        >Eliminar</a
      >
    </div>
  </div>

  <form action="" [formGroup]="formInsurance ? formInsurance : form">
    <!-- Tipo de seguro -->
    <div class="row">
      <label>Tipo de seguro <span class="required">*</span></label>
      <div class="selectWrapper">
        <div class="customSelect">
          <select name="" id="" formControlName="insuranceType">
            @for (insuranceTypes of insuranceService.insuranceList; track insuranceTypes.value) {
              <option
                *ngIf="insuranceTypes.isActive?.(typeInsuranceParams)"
                [value]="insuranceTypes.value"
                [hidden]="insuranceTypes.value == null"
              >
                {{ insuranceTypes.description }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
    <!-- Estado -->
    <div class="row">
      <label>Estado <span class="required">*</span></label>
      <div class="selectWrapper">
        <div class="customSelect">
          <select name="" id="" [attr.data-selected]="stateId" formControlName="stateId">
            @for (state of states(); track state.stateId) {
              <option [value]="state.stateId">
                {{ state.state }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
    @if (notIsTruckAndTracts) {
      <div class="row">
        <label for="">Uso<span class="required">*</span></label>
        <div class="selectWrapper">
          <div class="customSelect">
            <select name="" id="" formControlName="vehicleServiceType">
              <option *ngFor="let use of useList" [value]="use.value">
                {{ use.description }}
              </option>
            </select>
          </div>
        </div>
      </div>
    }
    @if (insuranceService.insuranceModel()?.modelType == modelEnum.autobuses) {
      <div class="row">
        <label for="">Cantidad de pasajeros<span class="required">*</span></label>
        <div class="inputWrapper">
          <div class="wrapperRemolques">
            <input
              type="number"
              id="quantityPassengersInput"
              (blur)="calculatePassenger($event)"
              formControlName="quantityPassengers"
              class="size1"
            />
            <div class="rango">
              <span class="note">Min {{ minPassenger }} / Max {{ maxPassenger }}</span>
            </div>
          </div>
        </div>
      </div>
    }
    <!-- Tipo de carga -->
    @if (isTruckAndTracts) {
      <div class="row">
        <label>Tipo de carga <span class="required">*</span></label>
        <div class="selectWrapper">
          <div class="customSelect">
            <select name="" id="" formControlName="loadType">
              <option value="A">A</option>
              <option value="B">B</option>
              <option value="C">C</option>
            </select>
          </div>
        </div>
      </div>
    }
    @if (isTracts) {
      <div class="row">
        <label for="">Número de remolques</label>
        <div class="inputWrapper">
          <div class="wrapperRemolques">
            <input
              type="number"
              id="quantityTrailers"
              formControlName="quantityTrailers"
              (blur)="onChangeQuantity()"
              class="size1"
            />
            <div class="rango">
              <span class="note">Min {{ minTrailers }} / Max {{ maxTrailers }}</span>
            </div>
          </div>
        </div>
      </div>
    }
  </form>
  <button class="tertiary" (click)="openInsuranceFlexModalMobile()" [disabled]="!isValidInsurance || !isModelValid()">
    Cotizar seguro
  </button>
</div>

<button
  class="tertiary"
  [ngClass]="{ addInsurance: quoteType() != 1 }"
  *ngIf="!showInsurance()"
  (click)="addInsurance()"
  [disabled]="!isValid() || !isValidInsuranceState || hasManualInsurance()"
>
  {{ quoteType() == 1 ? 'Agregar seguro broker' : 'Agregar seguro' }}
</button>

<ng-template #insuranceModalFlex>
  <app-insurance-flex-mobile
    [insurance]="formInsurance?.getRawValue()"
    [dealerBranch]="dealerBranch"
    (closed)="closeMobileFlexModal($event)"
  />
</ng-template>

<ng-template #modalConfirmation>
  <app-template-confirmation
    [title]="confirmationData().title"
    [subtitle]="confirmationData().subtitle"
    [btn1]="confirmationData().btn1"
    [btn2]="confirmationData().btn2"
    (closeModal)="closeConfirmationModal()"
    (actionBtn2)="editInsurance()"
  ></app-template-confirmation>
</ng-template>

<ng-template #insuranceSensitiveModal>
  <div class="modal" style="max-width: 620px">
    <a class="close" (click)="cancelInsuranceSensitiveEdit()">Cerrar</a>
    <h1>Eliminar propuestas</h1>
    <p>Está editando datos sensibles, si continúa con los cambios la propuesta de seguro será eliminada.</p>
    <div class="modalActions index">
      <button type="button" (click)="cancelInsuranceSensitiveEdit()" class="secondary">Cancelar</button>
      <button type="button" (click)="confirmInsuranceSensitiveEdit()" class="primary delete">Eliminar</button>
    </div>
  </div>
</ng-template>
